import { render } from "./LotteryExplain.vue?vue&type=template&id=c5185d5e&scoped=true"
import script from "./LotteryExplain.vue?vue&type=script&lang=js"
export * from "./LotteryExplain.vue?vue&type=script&lang=js"

import "./LotteryExplain.vue?vue&type=style&index=0&id=c5185d5e&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5185d5e"]])

export default __exports__